import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=61ea7396&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=61ea7396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ea7396",
  null
  
)

export default component.exports